var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"avatar",class:{
    'avatar--smaller': _vm.smaller,
  },style:(`background: ${_vm.color}`)},[_vm._v(" "+_vm._s(_vm.initials)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }